<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="3"
    height="18"
    viewBox="0 0 3 18"
    fill="currentColor"
    aria-hidden="true"
  >
    <rect width="3" height="18" rx="1.5" />
  </svg>
</template>
